<template>
    <div class="m-modal">
        <div class="m-modal-box">
            <close @click="close" data-jest="modal-close"/>
            <div class="l-element m-modal-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import Close from "../atoms/Close.vue";
    import {getGa4EventLabel} from "../../util/Ga4EventUtil.js";
    export default {
        name: "Modal",
        components: {Close},
        emits: ["close"],
        props: {
            /**
             * GA4に送るイベントラベルのテキスト.
             * modal表示時と、×ボタンを押した時に送信される
             */
            ga4EventLabel: {
                type: String,
                required: true
            }
        },
        created: function () {
            document.getElementsByTagName('body')[0].style.position = 'fixed';
            document.getElementsByTagName('body')[0].style.width = '100%';
            // モーダル表示時のGA4イベント送信
            getGa4EventLabel('SHOW_MODAL', this.ga4EventLabel);
        },
        unmounted: function() {
            document.getElementsByTagName('body')[0].style.position = 'relative';
        },
        methods: {
            close: function () {
                getGa4EventLabel('TAP_MODAL_CLOSE', this.ga4EventLabel);
                this.emit('close')
            },
            emit(emitName) {
                this.$emit(emitName);
            }
        }
    }
</script>
<style scoped lang="scss">
@use "../../../scss/v2/modules/modal";
</style>
